
const InputStyles: Record<string, React.CSSProperties> = {
    formContainer: {
        width: '100%',
        maxWidth: 400,
    },
    helpText: {
        color: "text.secondary",
        fontSize: 14,
        lineHeight: 20,
    },
    rightIcon: {
        color: "text.secondary",
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        right: 16,
        top: 36,
        width: 'auto',
    },
    disabled: {
        color: "action.disabled",
    },
    leftIcon: {
        marginLeft: 20,
        color: "action.disabled",
        alignItems: 'center',
        justifyContent: 'center',
    },
    container: {
        width: '100%',
        flex: 1,
    },
    text: {
        marginBottom: 0.5,
        fontFamily: 'Lemon-Milk-Pro-Regular',
        color: "text.primary",
        fontSize: 14,
        lineHeight: 2,
    },
    viewOnly: {
        width: '100%',
        maxWidth: 380,
        float: 'left',
        fontFamily: 'Plus Jakarta Sans',
    },
    viewText: {
        fontFamily: 'Plus Jakarta Sans',
        color: "text.primary",
        fontSize: 14,
        width: '100%',
    },
    textDark: {
        marginBottom: 5,
        color: "text.primary",
        fontSize: 14,
    },
    subText: {
        fontSize: 12,
        marginBottom: 5,
        marginTop: 5,
        color: "text.secondary",
    },
    errorText: {
        fontSize: 12,
        color: "errorRed.main",
        // marginBottom: 5,
        // position: 'absolute',
        minHeight: 24,
        // bottom: -32,
    },
    errorInput: {
        borderColor: "errorRed.main",
        borderWidth: 1,
    },
    focusInput: {
        borderColor: "primary.main",
        borderWidth: 1,
    },
    input: {
        flex: 1,
        backgroundColor: "background.paper",
        fontFamily: 'Plus Jakarta Sans',
        color: "text.primary",
        borderRadius: 5,
        borderColor: 'transparent',
        borderWidth: 1,
        alignItems: 'center',
        height: 44,
        fontSize: 14,
        outline: 'none',
    },
}

export default InputStyles;
